import QuickbooksApi from '../api/QuickbooksApi.js';
import { OPEN_QBO_DIALOG } from '../../Apps/AppDetails/Dialogs/QuickbooksConnectDialog.jsx';
import { SHOW_IMPORT_CONFIRMATION_DIALOG, QBO_ACCOUNT_INFO, SHOW_QBO_INTEGRATION_CARD_SPINNER } from '../../Apps/AppDetails/Redux/Actions';

import { ERROR_TEXT } from '../../Setup/Redux/Actions.js';
import { showErrorDialog } from '../../Common/CommonActions.js';

export function connectQBOOnCustomerList() {
  return (dispatch, getState) => QuickbooksApi.connectQBOOnCustomerList()
    .then((response) => {
      window.location.assign(response.data.url);
    })
    .catch((error) => dispatch({
      type: ERROR_TEXT,
      errorText: 'Problem contacting QuickBooks Online. Please try again or contact support for help.',
    }));
}

export function submitCCReconciliationAccount(id) {
  return (dispatch) => QuickbooksApi.updateCCReconciliationAccount(id)
    .then((response) => {
      dispatch({ type: QBO_ACCOUNT_INFO, qboAccountInfo: response.data });
    }).catch((error) => {
      if (error.response) {
        dispatch(showErrorDialog(error.response.data.error));
      }
    });
}

export function openImportDialog() {
  return (dispatch) => {
    dispatch({ type: SHOW_IMPORT_CONFIRMATION_DIALOG, showImportConfirmationDialog: true });
  };
}

export function openConnectToQboDialog() {
  return (dispatch) => {
    dispatch({ type: OPEN_QBO_DIALOG });
  };
}
